import { render } from "./editTruck.vue?vue&type=template&id=b32c0b22&scoped=true"
import script from "./editTruck.vue?vue&type=script&lang=js"
export * from "./editTruck.vue?vue&type=script&lang=js"

import "./editTruck.vue?vue&type=style&index=0&id=b32c0b22&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b32c0b22"]])

export default __exports__